export enum PropertyManagementFeature {
  DEBT_COLLECTION = 'Debt Collection',
  RENT_COLLECTION = 'Rent Collection',
  LEASE_RENEWALS = 'Lease Renewals',
  LEASING = 'Leasing',
  MAINTENANCE = 'Maintenance',
}
